import React from 'react';
import { Link } from 'react-router-dom';
import DocPage from '../../components/DocPage/DocPage';

function CookiePolicy() {
  return (
    <DocPage title="Cookie Policy" updated="Last updated: July 2026">
      <p>
        This Cookie Policy explains how Orbix ("we," "us," or "our") uses cookies and similar technologies on
        our website and platform. It should be read alongside our{' '}
        <Link to="/privacy-policy">Privacy Policy</Link>.
      </p>

      <h2>What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They help the site
        function, remember your preferences, and understand how the site is being used. Similar technologies
        such as pixels, local storage, and SDKs work in comparable ways, and we refer to all of them
        collectively as "cookies" in this policy.
      </p>

      <h2>The cookies we use</h2>
      <p>
        <strong>Strictly necessary cookies.</strong> These are required for the site and platform to work — for
        example, keeping you signed in, securing your session, and remembering items you've entered. You cannot
        switch these off without breaking core functionality.
      </p>
      <p>
        <strong>Functional cookies.</strong> These remember choices you make, such as your language or region,
        so we can provide a more personalized experience.
      </p>
      <p>
        <strong>Analytics cookies.</strong> These help us understand how visitors interact with our site —
        which pages are visited, how long people stay, and where they run into trouble — so we can improve the
        product. The data is aggregated and used to make Orbix better.
      </p>

      <h2>Managing your cookies</h2>
      <p>
        Most browsers let you view, manage, and delete cookies through their settings. You can usually choose
        to block cookies or be warned before one is set. Blocking strictly necessary cookies may prevent parts
        of the platform from working correctly.
      </p>
      <p>
        Where required by law, we ask for your consent before setting non-essential cookies, and you can change
        your preferences at any time.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Cookie Policy from time to time to reflect changes in technology, law, or how we
        operate. When we do, we'll revise the "Last updated" date above.
      </p>

      <h2>Contact us</h2>
      <p>
        If you have questions about how we use cookies, contact us at{' '}
        <a href="mailto:privacy@orbix.com">privacy@orbix.com</a>.
      </p>
    </DocPage>
  );
}

export default CookiePolicy;
